<ng-container *ngIf="!isLoading">
    <ng-container *ngFor="let alert of notiArray">
        <div fxFlex="0 1 auto" class="alert-card mat-elevation-z3 m-12 mr-20 p-12" [ngClass]="{'seen': alert.isDone}"
            (click)="handleNotification(alert)">

            <div fxLayout="row" fxLayoutAlign="space-between center" class="top-alert-card mb-12 font-size-12">
                <span>{{alert.createDate | date: 'dd/MM/yyyy HH:mm'}}</span>
            </div>

            <div class="mb-12">
                 <a style="text-decoration: none" *ngIf="!alert.isDone">
                <span class="font-size-14 alert-text">{{'NOTIFICATION_KEYS.' + alert.detail | translate}}</span>
                </a><!-- [href]="alert.url" -->
                <span class="font-size-14 alert-text" *ngIf="alert.isDone">{{'NOTIFICATION_KEYS.' + alert.detail |
                    translate}}</span>
                
                <div *ngIf="alert.notificationTypeId == 4" class="mt-8">
                    <span class="font-size-14" *ngIf="alert.complaintCode" style="display: block;">
                        <b>{{'COMPLAINTS.FIELDS.CODE' | translate}}:</b> {{alert.complaintCode}}</span>
                    <span class="font-size-14" *ngIf="alert.complaintType" style="display: block;">
                        <b>{{'REPORTS.FLAT.COMPLAINTTYPE' | translate}}:</b> {{alert.complaintType}}</span>
                    <span class="font-size-14" *ngIf="alert.complaintClassification" style="display: block;">
                        <b>{{'COMPLAINTS.FIELDS.COMPLAINTCLASSIFICATIONDESCRIPTION' | translate}}:</b> {{alert.complaintClassification}}</span>
                </div>
            </div>

            <div fxLayout="row" fxLayoutAlign="flex-end center">
                <div fxLayout="row" fxLayoutAlign="flex-start center">

                    <ng-container *ngIf="alert.isDone">
                        <mat-icon class="secondary-text seen-alert-card m-8"
                            matTooltip="{{'NOTIFICATIONS-PANEL.ALERT-SEEN' | translate}}">drafts</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="!alert.isDone">
                        <button mat-icon-button (click)="(alert.notificationTypeId != 7 && alert.notificationTypeId != 8 && alert.notificationTypeId != 9) ? alertOpened(alert) : handleNotification(alert)" aria-label="Toggle notifications panel"
                            matTooltip="{{'NOTIFICATIONS-PANEL.ALERT-NOTSEEN' | translate}}">
                            <mat-icon class="secondary-text seen-alert-card">mail</mat-icon>
                        </button>
                    </ng-container>

                </div>
            </div>

        </div>
    </ng-container>

    <fade-in-animation *ngIf="!notiArray || !notiArray.length">
        <no-data-card [panel]="panelNames.notificationPanel" class="m-12 mr-20"></no-data-card>
    </fade-in-animation>

</ng-container>

<fading-loading-animation *ngIf="isLoading">
    <striped-bars-card class="m-12 mr-20"></striped-bars-card>
    <striped-bars-card class="m-12 mr-20"></striped-bars-card>
    <striped-bars-card class="m-12 mr-20"></striped-bars-card>
</fading-loading-animation>